<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { Constants } from '@/constants';

const { t } = useI18n();

// PROPS
const props = defineProps<{
  status: number;
}>();

// COMPUTED
const consultationStatusTitleCase = computed(() => {
  const statusMap: Record<number, string> = {
    [Constants.Consultation.Status.Completed]: t('consultation.status.options.completed'),
    [Constants.Consultation.Status.Archived]: t('consultation.status.options.archived'),
  };
  return statusMap[props.status] || '';
});

const message = computed(() => {
  const keyMap: Record<number, string> = {
    [Constants.Consultation.Status.Completed]: 'consultation.status.completedMessage.completed.message',
    [Constants.Consultation.Status.Archived]: 'consultation.status.completedMessage.archived.message',
  };
  return t(keyMap[props.status] || '');
});

const important = computed(() => {
  const keyMap: Record<number, string> = {
    [Constants.Consultation.Status.Completed]: 'consultation.status.completedMessage.completed.important',
    [Constants.Consultation.Status.Archived]: 'consultation.status.completedMessage.archived.important',
  };
  return t(keyMap[props.status] || '');
});
</script>
<template>
  <q-banner dense class="bg-primary text-white">
    <strong>{{ t('consultation.status.completedMessage.title', { status: consultationStatusTitleCase }) }}</strong>
    <br />
    {{ message }}
    <br />
    {{ important }}
  </q-banner>
</template>
